<div class="header-bar">
  <div class="header-left"></div>
  <div class="header-center">
    {{ newCategory ? ('Create ' + categoryTypeText) : ('Edit ' + categoryTypeText) }}
  </div>

  <div *ngIf="newCategory" class="header-right">
    <button mat-button color="fiord" (click)="cancel()">Cancel</button>
    <button
      mat-button
      color="lightGreen"
      (click)="saveNewCategory()"
      [disabled]="saveDisabled"
    >
      Save New Category
    </button>
  </div>

  <div *ngIf="!newCategory" class="header-right">
    <button mat-button color="warn" (click)="deleteCategory()">
      Delete Category
    </button>
    <button
      mat-button
      color="lightGreen"
      (click)="saveCategoryUpdates()"
      [disabled]="saveDisabled"
    >
      Save Category Updates
    </button>
  </div>
</div>

<div class="category">
  <div class="containers">
    <div class="left-column">
      <div class="container category-details-container">
        <div class="container-header no-bottom-border">
          <div class="text">Category Details</div>
        </div>
        <div class="container-content">
          <div class="container-row">
            <lhpe-input
              class="input"
              controlName="name"
              placeholder="Category Name"
              [formGroup]="categoryForm"
              [required]="true"
            ></lhpe-input>
          </div>
        </div>
      </div>
    </div>

    <div class="right-column">
      <!-- IMAGE -->
      <div class="container image-container">
        <div class="container-header no-bottom-border">
          <div class="text">Image</div>
        </div>
        <div class="container-content">
          <!-- Show selected media if one exists -->
          <div class="container-row" *ngIf="selectedMedia">
            <div class="selected-media">
              <span>Selected:</span>
              <img [src]="selectedMedia.url"
                   [alt]="selectedMedia.description"
                   width="50" />
              <span>{{ selectedMedia.description }}</span>
              <button mat-icon-button
                      color="warn"
                      aria-label="Remove selected media"
                      (click)="clearMedia()">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>

          <!-- Show search and upload sections only if no media is selected -->
          <ng-container *ngIf="!selectedMedia">
            <lhpe-input
              class="input search-input"
              controlName="mediaSearch"
              placeholder="Search Existing Media"
              [formGroup]="categoryForm"
              [matAutocomplete]="mediaAuto"
            ></lhpe-input>
            <mat-autocomplete
              #mediaAuto="matAutocomplete"
              (optionSelected)="onMediaSelected($event.option.value)"
            >
              <mat-option
                *ngFor="let media of filteredMedias"
                [value]="media"
              >
                {{ media.description }}
              </mat-option>
            </mat-autocomplete>

            <!-- Divider with "or" -->
            <div class="divider-container">
              <div class="divider-line"></div>
              <span class="divider-text">or</span>
              <div class="divider-line"></div>
            </div>

            <!-- Upload section -->
            <div class="upload-section">
                <lhpe-input
                  *ngIf="uploadFile"
                  class="input desc-input"
                  controlName="imageName"
                  placeholder="Image Name"
                  [formGroup]="categoryForm"
                  [required]="true"
                ></lhpe-input>

                <ngx-file-drop
                  dropZoneLabel="Drop files here"
                  accept=".png,.jpg,.jpeg,.svg"
                  [directory]="false"
                  [multiple]="false"
                  (onFileDrop)="dropped($event)"
                >
                  <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                    <ng-container *ngIf="!uploadFile">
                      <button
                        mat-button
                        class="icon-btn upload-icon"
                        (click)="openFileSelector()"
                      >
                        <svg-icon src="assets/svg/image-upload.svg"></svg-icon>
                      </button>
                      <div class="">Drag and drop image here</div>
                      <div class="">- or -</div>
                      <div class="">click to browse files</div>
                    </ng-container>
                    <ng-container *ngIf="uploadFile">
                      <svg-icon
                        class="upload-icon"
                        src="assets/svg/image-upload.svg"
                      ></svg-icon>

                      <div class="img-name">
                        {{ uploadFile.name }}
                      </div>
                      <div class="">
                        {{ uploadImageWidth ? uploadImageWidth : "unknown" }}px x
                        {{ uploadImageHeight ? uploadImageHeight : "unknown" }}px
                      </div>
                      <div class="">{{ uploadFile.size | filesize }}</div>
                      <div class="cancel-btn" (click)="removeUploadFile()">Cancel</div>
                    </ng-container>
                  </ng-template>
                </ngx-file-drop>

                <div *ngIf="!uploadFile" class="optimal-size">
                  Optimal image size: px wide x px tall
                </div>
                <div class="button-row" *ngIf="uploadFile">
                  <button
                    mat-button
                    color="lightGreen"
                    [disabled]="uploadDisabled"
                    (click)="uploadImage()"
                  >
                    Upload image
                  </button>
                  <button mat-button color="fiord" (click)="removeUploadFile()">
                    Cancel
                  </button>
                </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
